module.exports = "/images/aig.png?034b82991c6b1fe2b823341911f4571f";